(() => {
  const selector = '.za-accessory-card,.tog-au-card';
  let queued = false;
  let root;
  function align() {
    queued = false;
    // Batch visibility reads, height resets, measurements, then final writes.
    const cards = [...root.querySelectorAll(selector)]
      .filter(card => card.getClientRects().length && card.getBoundingClientRect().width > 0)
      .map(card => ({title: card.querySelector('h3,.tog-au-card__title'),
        price: card.querySelector('.za-accessory-price,.tog-au-card__price')}))
      .filter(({title, price}) => title && price);
    cards.forEach(({title, price}) => {
      title.style.setProperty('min-height', '0', 'important');
      price.style.setProperty('min-height', '0', 'important');
    });
    const rows = new Map();
    cards.forEach(({title, price}) => {
      const box = title.getBoundingClientRect();
      const top = Math.round(box.top / 3) * 3;
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push({title, price, th: box.height, ph: price.getBoundingClientRect().height});
    });
    rows.forEach(row => {
      const th = Math.max(...row.map(x => x.th)) + 'px';
      const ph = Math.max(...row.map(x => x.ph)) + 'px';
      row.forEach(({title, price}) => {
        title.style.setProperty('min-height', th, 'important');
        price.style.setProperty('min-height', ph, 'important');
      });
    });
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(align); }
  }
  function containsCards(node) {
    return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
  }
  function start() {
    root = document.querySelector('.tog-au-home') || document.querySelector('#MainContent');
    if (!root || !root.querySelector(selector)) return;
    schedule();
    // Ignore chat, menu, pixels and unrelated DOM changes.
    new MutationObserver(records => {
      if (records.some(record => record.type === 'childList'
        ? record.target.closest(selector) || [...record.addedNodes, ...record.removedNodes].some(containsCards)
        : containsCards(record.target))) schedule();
    }).observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden']});
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(schedule, 100);
    }, {passive: true});
    window.addEventListener('load', schedule, {once: true});
    if (document.fonts) document.fonts.ready.then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
